import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  NgZone,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { DropdownItem, DropdownItemValue } from '../../../global/types/DropdownItem';
import { AbstractCloseOnClickOut } from '../../../global/abstractions/AbstractCloseOnClickOut';

export enum DropDownTypeEnum {
  simple = 'simple',
  box = 'box',
}

// @ts-ignore
@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.less'],
})
export class DropdownComponent extends AbstractCloseOnClickOut implements OnInit, OnChanges {
  @Input() icon: string;
  @Input() defaultValue: DropdownItemValue;
  @Input() items: DropdownItem[];
  @Input() dropDownType: DropDownTypeEnum;
  @Input()selectedItem: DropdownItem;
  @Input() placeholder: string;
  @Input() withCircle: boolean;
  @Input() testId: string;

  clonedItems: DropdownItem[];

  placeholderValue: string;

  dropDownTypeEnum = DropDownTypeEnum;

  @ViewChild('dropdownElement', { static: true }) dropdownElement: ElementRef;
  clicks = 0;

  /**
   * @deprecated Use selectedItemChange which supports 2 way binding
   */
  // tslint:disable-next-line:no-output-native
  @Output()
  change = new EventEmitter<DropdownItemValue>();

  @Output()
  selectedItemChange = new EventEmitter<DropdownItem>();

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.defaultValue && changes.defaultValue.currentValue !== this.selectedItem?.value)
      this.selectDefaultItem();
    this.clonedItems = [...this.items];
  }

  ngOnInit(): void {
    if (this.defaultValue) this.selectDefaultItem();
    this.placeholderValue = this.placeholder ? this.placeholder : 'Select item';
  }

  selectDefaultItem() {
    this.selectedItem =
      !this.selectedItem &&
      this.clonedItems?.find((item) => (this.defaultValue ? item.value === this.defaultValue : !item.value));
  }

  selectItem(item: DropdownItem) {
    if (!item) return;
    this.selectedItem = item;
    this.close();
    if (this.defaultValue) this.change.emit(item.value);
    this.selectedItemChange.emit(item);
  }

  @HostListener('document:click', ['$event'])
  onClick(event) {
    if (!this.dropdownElement.nativeElement.contains(event.target)) {
      this.clicks += 1;
      if (this.clicks >= 2) {
        this.clicks = 0;
        this.close();
      }
    } else {
      this.clicks = 1;
    }
  }
}
